import { FC } from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { StoragesValuesView } from "../../../../../redux/slices/grainTracker/grainTrackerTypes";
import { stylesGeneralComponents } from "../../../../StylesMuiGeneralComponents";
import { LoadingButton } from "@mui/lab";
import { FetchingSharingStatusData } from "../../../../../redux/slices/shareSite/shareSiteTypes";

type ShareSiteSelectAllParams = {
  setSelectedStoragesIds: (values: string[]) => void;
  storages: StoragesValuesView[];
  storagesLoading: boolean;
  storageSharingLoading: boolean;
  storageSharedDeleteLoading: boolean;
  setToDelete: (values: string[]) => void;
  sharingStatus: FetchingSharingStatusData;
};

const ShareSiteButtonSelectAll: FC<ShareSiteSelectAllParams> = ({
  setSelectedStoragesIds,
  storages,
  storagesLoading,
  storageSharedDeleteLoading,
  storageSharingLoading,
  setToDelete,
  sharingStatus,
}) => {
  const [t] = useTranslation("global");

  const sharingStatusObject = sharingStatus.data.map((val) => ({
    id: val.id,
    storageInstanceId: val.storageInstanceId,
    sharingIsForced: val.sharingIsForced,
  }));

  const storagesWithStatusInformation = storages.reduce((arr: any, e: any) => {
    arr.push(
      Object.assign({}, e, {
        sharingStatus: sharingStatusObject.find(
          (a) => a.storageInstanceId === e.id
        ),
      })
    );
    return arr;
  }, []) as StoragesValuesView[];

  const selectAll = () => {
    setToDelete([]);
    setSelectedStoragesIds(
      storagesWithStatusInformation.map((card) => card.id)
    );
  };

  return (
    <Box sx={stylesGeneralComponents.boxButtonFiltersShareSite}>
      <LoadingButton
        onClick={() => selectAll()}
        loading={
          storagesLoading || storageSharedDeleteLoading || storageSharingLoading
        }
        loadingPosition="end"
        variant="text"
        sx={stylesGeneralComponents.buttonStyles}
      >
        {t("Share_site.select-all")}
      </LoadingButton>
    </Box>
  );
};

export default ShareSiteButtonSelectAll;
